import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWrench } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import type { TaskListItemModel, TemplatePageModel } from '@domain-group/realhub-backend-api-types'

import useTemplateTestingLink from '@hooks/useTemplateTestingLink'
import handleCallbackAction from '@functions/handleCallbackAction'

interface TestTemplateButtonProps {
  taskListItem: TaskListItemModel,
  templatePage: TemplatePageModel,
}

const TestTemplateButton = (props: TestTemplateButtonProps) => {
  const { taskListItem, templatePage } = props

  const templateTestingLinkPayload = useTemplateTestingLink({ taskListItem, templatePage })
  const {
    buttonText,
    callbacks: {
      onClick,
    },
    disabled,
    hasArtwork,
    href,
  } = templateTestingLinkPayload

  const setupTestPayload = {
    callbacks: {
      action: onClick,
    },
  }

  return (
    <Button
      // @ts-expect-error TS2322
      as={hasArtwork ? 'a' : 'button'}
      buttonStyle="secondaryUtility"
      disabled={disabled}
      href={href}
      icon={<FontAwesomeIcon icon={faWrench} />}
      // @ts-expect-error TS2345
      onClick={() => handleCallbackAction(setupTestPayload)}
      size="medium"
      width="calc(50% - 4px)"
    >
      {buttonText}
    </Button>
  )
}

export default TestTemplateButton
